import React from 'react';

const ClearbitIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 24 24">
        <path
            fill={color}
            fillOpacity=".35"
            d="M22 12v4.659c0 1.857-.193 2.53-.556 3.21a3.786 3.786 0 0 1-1.576 1.574c-.679.364-1.352.557-3.21.557H12V12h10Z"
        />
        <path
            fill={color}
            fillOpacity=".50"
            d="M22 12v4.659c0 1.857-.193 2.53-.556 3.21a3.786 3.786 0 0 1-1.576 1.574c-.679.364-1.352.557-3.21.557H12V12h10Z"
        />
        <path
            fill={color}
            d="M12 2h4.659c1.857 0 2.53.193 3.21.557a3.787 3.787 0 0 1 1.575 1.575c.363.679.556 1.352.556 3.21V12H12V2Z"
        />
        <path
            fill={color}
            fillOpacity=".50"
            d="M7.341 2H12v20H7.341c-1.857 0-2.53-.194-3.21-.557a3.786 3.786 0 0 1-1.574-1.575C2.193 19.19 2 18.516 2 16.658V7.341c0-1.857.193-2.53.557-3.21a3.786 3.786 0 0 1 1.575-1.574C4.81 2.193 5.484 2 7.342 2Z"
        />
    </svg>
);

export default ClearbitIcon;
